import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';

/**
 * Checks to see if dime Unipux is enabled
 */
export const dimeUnipuxCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return (
            isGlobalFeatureEnabled('dime-unipux-basic') &&
            isGlobalFeatureEnabled('auth-naa-inline-bridge')
        );
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
};
